export const cellKey = {
    name: 1,
    username: 2,
    email: 3,
    street: 4,
    suite: 5,
    city: 6,
    zipcode: 7,
    phone: 8,
    website: 9,
    companyName: 10,
    catchPhrase: 11,
    bs: 12
};